import React, { Fragment } from 'react'
import BuildingSelector from './BuildingSelector'
import UserAvatar from './UserAvatar'
import history from '../../../History'
import Search from '../../Search'
import '../../../styles/Navigation.css'
import { useSelector } from 'react-redux'
import IamSafeButton from '../../IamSafeButton'

function HeaderNavigation() {
    const isAdmin = useSelector(state => state.app.isAdmin)

    return (
        <Fragment>
            <BuildingSelector />

             <UserAvatar onClick={() => history.push('/profile')} /> 
             {isAdmin && <Search />}
             <IamSafeButton />
        </Fragment>
    )
}

export default HeaderNavigation
